module.exports = __webpack_public_path__ + "static/media/Photo_direction_symbol.0d9214e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/Photo_direction_symbol.svg
// module id = 482
// module chunks = 0